// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import BasePrice from './BasePrice';
import useAccessibleEndpointsByGroups from '../../../hooks/useAccessibleEndpointsByGroups';
import BasePricesLayout from './components/BasePricesLayout';
import NextBasePrice from './NextBasePrice';
import NextBasePriceEdit from './NextBasePriceEdit';
import BasePriceEdit from './BasePriceEdit';

function BasePrices({ tabEndpoints }) {
  const { path } = useRouteMatch();
  const availableTabs = useAccessibleEndpointsByGroups(tabEndpoints);
  return (
    <>
      <Box>
        <Switch>
          <Route
            exact
            path={[`${path}`, `${path}/next-base-prices`, `${path}`]}
          >
            <BasePricesLayout availableTabs={availableTabs}>
              <Switch>
                {availableTabs.includes('/next-base-prices') && (
                  <Route
                    path={`${path}/next-base-prices`}
                    render={() => <NextBasePrice />}
                  />
                )}
                {availableTabs.includes('/') && (
                  <Route path={`${path}`} render={() => <BasePrice />} />
                )}
              </Switch>
            </BasePricesLayout>
          </Route>

          <Route
            path={`${path}/next-base-prices/:id(new|\\d+)`}
            render={() => <NextBasePriceEdit />}
          />

          <Route
            path={`${path}/:id(new|\\d+)`}
            render={() => <BasePriceEdit />}
          />
          <Redirect from={`${path}*`} to={`${path}${availableTabs[0]}`} />
        </Switch>
      </Box>
    </>
  );
}

export default BasePrices;
